import {Field, Form, Formik} from 'formik'
import * as Yup from 'yup'
import {toast} from 'react-toastify'
import {useIntl} from 'react-intl'
import {useNavigate} from 'react-router-dom'
import Logo from 'src/_metronic/assets/logo.png'
import BG from '../asset/bg.png'
import {LanguageList} from '../helper/languageList'
import {useMerchantData} from 'src/feature/become-merchant/hook'
import {API} from 'src/feature/bite/domain'
import {useState} from 'react'
import useRequestParams from 'src/feature/bite/hook/request'

const developmentMode = process.env.NODE_ENV === 'development'

function ActivatePage() {
  const intl = useIntl()
  const navigate = useNavigate()
  const {merchantDataSet} = useMerchantData()
  const {headers} = useRequestParams()
  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = async (values) => {
    setIsLoading(true)
    const Response = await fetch(`${API}/Merchant/BecomaAMerchantValidateActivationCode`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      body: JSON.stringify({
        ...values,
        language: headers.Language,
      }),
    })

    const data = await Response.json()

    if (!data.responseResult.result) {
      //toast.error(intl.formatMessage({ id: 'AUTH.LOGIN.ACTIVATE_ERROR' }), {
      toast.error(data.responseResult.exceptionDetail, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: 'light',
      })

      setIsLoading(false)
      return
    }

    let merchantDataResponse = data.response

    // if (merchantDataResponse.phone) {
    //   merchantDataResponse.phone = `+1 (${merchantDataResponse.phone?.slice(0, 3)}) ${merchantDataResponse.phone?.slice(3, 6)}-${merchantDataResponse.phone?.slice(6)}`
    // }

    merchantDataSet(merchantDataResponse)

    navigate('/become-a-merchant/merchant-form')
  }

  const validationSchema = Yup.object({
    merchantEmail: Yup.string()
      .email(intl.formatMessage({id: 'GLOBAL.VALIDATION.EMAIL'}))
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(100, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 100})),
    activationCode: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(6, intl.formatMessage({id: 'GLOBAL.ERROR.MIN_LIMIT_INPUT'}, {length: 6})),
  })

  return (
    <>
      <div className='d-flex flex-column flex-root' id='kt_app_root'>
        <div className='d-flex flex-column flex-lg-row flex-column-fluid'>
          <a href='sign-in' className='d-block d-lg-none mx-auto pt-10'>
            <img alt='Logo' src={Logo} className='h-25px' />
          </a>

          <div className='d-flex flex-column flex-column-fluid flex-center w-lg-50 p-10'>
            <div className='d-flex justify-content-start flex-column-fluid flex-column w-100 mw-550px gap-20'>
              <div className='d-flex flex-stack py-2'>
                <div className='m-0'>
                  <div className='d-none d-md-block'>
                    <img
                      alt='Extra360 - Merchant Portal'
                      src={Logo}
                      style={{
                        width: '250px',
                      }}
                    />
                  </div>
                  <h1
                    className='mb-3 fs-3x mt-0 mt-md-3'
                    data-kt-translate='sign-in-title'
                    style={{
                      color: '#5C5C5C',
                    }}
                  >
                    {intl.formatMessage({id: 'APP_NAME'})}
                  </h1>
                </div>
              </div>

              <div className='mt-20'>
                <Formik
                  initialValues={{
                    merchantEmail: developmentMode ? 'alex.roe@mystore.com' : '',
                    activationCode: developmentMode ? '123456' : '',
                  }}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {({errors, touched, setFieldValue}) => (
                    <Form className='form w-100'>
                      <div className='card-body'>
                        <div className='text-start mb-10'>
                          <h1 className='text-primary mb-3 fs-2x' data-kt-translate='sign-in-title'>
                            {intl.formatMessage({id: 'AUTH.LOGIN.ACTIVATE'})}
                          </h1>

                          <div
                            className='text-gray-400 fw-semibold fs-6'
                            data-kt-translate='general-desc'
                          >
                            {intl.formatMessage({id: 'AUTH.LOGIN.ACTIVATE_DESC'})}
                          </div>
                        </div>

                        <div className='fv-row mb-8 form-floating'>
                          <Field
                            name='merchantEmail'
                            className='form-control'
                            type='email'
                            id='merchantEmail'
                            placeholder={intl.formatMessage({id: 'AUTH.INPUT.EMAIL'})}
                            maxLength={101}
                          />
                          <label>{intl.formatMessage({id: 'AUTH.INPUT.EMAIL'})}</label>
                          {errors.merchantEmail && touched.merchantEmail ? (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{errors.merchantEmail}</div>
                            </div>
                          ) : null}
                        </div>

                        <div className='fv-row mb-7 form-floating'>
                          <Field
                            id='activationCode'
                            name='activationCode'
                            type='text'
                            className='form-control'
                            placeholder=''
                            maxLength='6'
                          />
                          <label>{intl.formatMessage({id: 'AUTH.LOGIN.ACTIVATE_CODE'})}</label>
                          {errors.activationCode && touched.activationCode ? (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{errors.activationCode}</div>
                            </div>
                          ) : null}
                        </div>

                        <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-10'>
                          <div>
                            <div className='d-flex flex-stack'>
                              {isLoading ? (
                                <button className='btn btn-primary me-2 flex-shrink-0' disabled>
                                  <i className='bi bi-arrow-right me-3 fs-3'></i>
                                  <span
                                    className='indicator-label'
                                    data-kt-translate='sign-in-submit'
                                  >
                                    {intl.formatMessage({id: 'AUTH.LOGIN.ACTIVATE_BTN'})}
                                  </span>

                                  <span className='indicator-progress'>
                                    <span data-kt-translate='general-progress'>Please wait...</span>
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                  </span>
                                </button>
                              ) : (
                                <button
                                  id='kt_sign_in_submit'
                                  className='btn btn-primary me-2 flex-shrink-0'
                                >
                                  <i className='bi bi-arrow-right me-3 fs-3'></i>
                                  <span
                                    className='indicator-label'
                                    data-kt-translate='sign-in-submit'
                                  >
                                    {intl.formatMessage({id: 'AUTH.LOGIN.ACTIVATE_BTN'})}
                                  </span>

                                  <span className='indicator-progress'>
                                    <span data-kt-translate='general-progress'>Please wait...</span>
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                  </span>
                                </button>
                              )}
                            </div>
                          </div>

                          <a href='/' data-kt-translate='sign-in'>
                            {intl.formatMessage({id: 'AUTH.LOGIN.TITLE'})}
                          </a>
                        </div>
                      </div>
                      <div className='mt-10'>
                        <LanguageList />
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>

          <div
            className='d-none d-lg-flex flex-lg-row-fluid w-50 bgi-size-cover bgi-position-y-center bgi-position-x-start bgi-no-repeat'
            style={{
              backgroundImage: `url(${BG})`,
            }}
          ></div>
        </div>
      </div>
    </>
  )
}

export default ActivatePage
